import {
  ISearchFieldFilters,
  ISearchOrder,
  ISearchPage,
} from 'interfaces/ISearch';
import { IdName } from 'interfaces/IdName';
import { SortDirections } from 'constants/sortDirections';

export enum UnitEnum {
  KM = 'km',
  MILES = 'mi',
  METERS = 'm',
}

export interface IPropertySearchFilters {
  fields?: ISearchFieldFilters;
  markets?: IdName[];
  submarkets?: IdName[];
  micromarkets?: IdName[];
  propertyClasses?: IdName[];
  propertyStatuses?: IdName[];
  propertyTypes?: string[];
  propertySubtypes?: IdName[];
  propertySubtypeDetails?: IdName[];
  owners?: IdName[];
  competitiveSetPropertyId?: number;
  competitiveSetIncludeProperty?: boolean;
  withSummary?: boolean;
  ids?: number[];
  overlapIds?: boolean;
  orderField?: string;
  orderDirection?: SortDirections;
  propertyId?: number;
  excludedIds?: number[];
  includeInStats?: boolean;
  paramIds?: number[];
  longLeaseHolders?: IdName[];
  cities?: IdName[];
}

export interface IPropertySearch {
  filter?: IPropertySearchFilters;
  page?: ISearchPage;
  order?: ISearchOrder;
  createUpdate?: boolean;
}
